import(/* webpackMode: "eager" */ "/app/apps/ui/src/components/elementary/AppLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KnockAiLazy"] */ "/app/apps/ui/src/components/elementary/footer/KnockAiLazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/apps/ui/src/components/elementary/navbar/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptimizedImage"] */ "/app/apps/ui/src/components/elementary/OptimizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
